<template>
<!-- Contains start/edit button (launches modal), display results -->
  <div class="open-services-tree-naics-lookup">
    <div v-if="!mx_isMobile()">
      <div v-if="this.getAllSavedValues.naics.length == 0">
        <b-button class="start-button" :lang="mx_toggleLang" :label="getLabel" type="is-info" size="is-small" tabindex="0" @click="mx_homeModal()" />
      </div>
      <div v-else>
        <span v-if="toggleResults == '1' || toggleResults == '2' || toggleResults == '3'">
          <span v-for="(item, index) in getAllSavedValues.naics" :key="index"> 
            <span v-if="toggleResults == '1'">
               {{ item.code }} - {{ item.name }}<br />
            </span>
            <span v-if="toggleResults == '2'">
              {{ item.name }}<br />
            </span>
            <span v-if="toggleResults == '3'">
              {{ item.code }}<span v-if="index != getAllSavedValues.naics.length-1">, </span>
            </span>
          </span>
          <br v-if="toggleResults == '3'" />
          <b-button class="edit-button" :label="$t('edit_button')" type="is-info" size="is-small" tabindex="0" @click="mx_editInfo()" />
        </span>
        <span v-else>
          <b-button class="edit-button" :label="$t('edit_button') + ' (' + getAllSavedValues.naics.length + ')'" type="is-info" size="is-small" tabindex="0" @click="mx_editInfo()" />
        </span>
        <b-button class="reset-button" :label="$t('reset_button')" type="is-info is-light" size="is-small" tabindex="0" @click="mx_resetInfo()" />
      </div>
    </div>
    <div v-else>
      <MobileHome
        :lang="this.mx_toggleLang"
        :multiple="this.mx_toggleMultiple"
        :resultstree="this.getTreeStructure"
        :showCode="this.mx_toggleShowCode"
        :showResults="this.showResults"
        @save="saveMobile"
      ></MobileHome>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import mainBaseMixin from './main-mixin.js';
import OpenServicesErrorsComponent from "@bizpal/open-services-errors-component";
import VueGtag from "vue-gtag";
import fullNaicsEn from "./data/naics-2017-en";
import fullNaicsFr from "./data/naics-2017-fr";
import { getAPIConnexion } from "./services/API_Directus.js";
import MobileHome from "./components/MobileHome.vue";

Vue.component("open-services-errors-component", OpenServicesErrorsComponent);
Vue.use(VueGtag, {
  config: { 
    id: process.env.VUE_APP_GA4TAG_ID || "G-9XEJCX5YB5", // default to LIVE GA4 ID
    params: {
      send_page_view: false
    }
  },
  includes: [
    {
      id: process.env.VUE_APP_GTAG_ID || "UA-21143245-13", // default to LIVE GA ID    ****old****
      params: {
        send_page_view: false
      }
    }
  ]
});

export default {
  name: 'OpenServicesTreeNaicsLookup', // vue component name
  mixins: [mainBaseMixin],
  i18n: {
    locale: "en",
    messages: {
      en: {
        select_industry_button: "Select your industry | Select your industries",
        edit_button: "Edit",
        reset_button: "Reset"
      },
      fr: {
        select_industry_button: "Choisir votre industrie | Choisir vos industries",
        edit_button: "Éditer",
        reset_button: "Réinitialiser"
      }
    }
  }, // end i18n
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    lang: {
      type: String,
      default: "en"
    },
    showCode: {
      type: Boolean,
      default: true
    },
    showResults:{
      type: String,
      default: ""
    },
    levelSelectable: {
      type: String,      
      default: "2",
      validator: function (value) {
        // The value must match one of these strings
        let arrayValide = ["2","3","4","5"];
        let valide = arrayValide.indexOf(value) !== -1 ? true : false;
        return valide;
      }
    }
  }, // end props
  components: { MobileHome },
  mounted: function() {
    this.$i18n.locale = this.mx_toggleLang;
    let treeStructure = (this.mx_toggleLang == "en") ? fullNaicsEn : fullNaicsFr;
    this.updateInitTree(treeStructure);
    this.updateSavedTree(treeStructure);
    this.updateReducedTree(treeStructure);
    this.toggleLevel;
    this.mapTopLevelNaics(treeStructure);
    this.retreiveAllIndustries();
    document.title = "NAICS Tree App";
  }, // end mounted
  computed: {
    getLabel: function() {
      return this.label != "" ? this.label : this.multiple ? this.$tc('select_industry_button', 2) : this.$tc('select_industry_button', 1);
    },
    toggleResults: function() {
      return this.showResults;
    },
    toggleLevel: function() {
      let arrayLevel = this.levelSelectable.split("nosepratoranymore"); // quick wait to make array 
      this.updateLevelSelectable(arrayLevel);
      return arrayLevel;
    }, // end toggleLevel
    getTreeStructure: function() {
      return this.resultsTree;
    }
  }, // end computed
  watch: {
    levelSelectable: function() {
      this.toggleLevel;
    },
    lang: function() {
      this.$i18n.locale = this.mx_toggleLang;
      this.retreiveAllIndustries();
      let treeStructure = (this.mx_toggleLang == "en") ? fullNaicsEn : fullNaicsFr;
      this.updateInitTree(treeStructure);
      this.updateSavedTree(treeStructure);
      this.updateReducedTree(treeStructure);   
      //reset app to inital state because changing lang
      this.updateAllChecked({
        key: "naics",
        payload: []
      });       
      this.updateAllSaved({
        key: "naics",
        payload: []
      });        
      this.updateHasNoSelection(true);      
      this.updateHasResults(false);
    } // end lang
  }, // end watch
  methods: {
    mapTopLevelNaics: function(initTree) {
      // some top level naics are like this format 31-33, 
      // so will transform to {31:"31-33",32:"31-33"} etc        
      let mappingNaics = {};

      initTree.forEach(topLevel => {
        let arrayNaics = topLevel.id.split("-");
        let start = parseInt(arrayNaics[0]);
        let end = parseInt(arrayNaics[arrayNaics.length-1]);
         
        for (let i = start; i <= end; i++) {
          mappingNaics[i.toString()] = topLevel.id;
        } // for
      }); // foreach

      this.updateMapTopLevelNaics(mappingNaics);
    }, // end mapTopLevelNaics,
    retreiveAllIndustries: function() {
      getAPIConnexion("", this.lang, process.env.VUE_APP_DIRECTUS)
        .then(response => {
          //transform response to be associative array with index as id
          let tempArray = {}; 
          response.data.data["naics_2017"].forEach(element => {
            tempArray[`${element.id}`] =  element;
          })             
          this.updateAllIndustriesDirecturs(tempArray); 
        })
        .catch(err => {
          console.log(err);
          this.$emit("errored", true);
        });
    }, // end retreiveAllIndustries
    clear: function() {
      this.$gtag.event("industries-clear-all", {
        event_category: "naics-tree-widget",
        event_label: "user clear all industries selection",
        product: process.env.VUE_APP_PRODUCT
      });
      this.clearAll = true;
    }, // end clear
    treeCleared: function() {
      this.clearAll = false;
    },
    updateTree: function(event) {
      this.treeNodes = event;
    },
    updateResults: function(event) {
      this.results = event;
    },
    treeValues: function(event) {
      this.selectValues = [];
      this.selectValues = event;
    },
    treeSelect: function(event) {
      this.selectTree = event;
    },
    getError: function(event){
      this.error = event;
    },
    updateExamples: function(event) {
      this.examplesByNaics = event;
    },
    save: function(value) {
      if (value.naics != null) {
        let payload = {};
        payload.naics = value.naics.map(function(el) { return { code: el.code, name: el.name } });
        this.$emit("change", payload);
      }
    }, // end save
    saveMobile: function(value) {
      if (value.naics != null) {
        let payload = {};
        payload.naics = value.naics.map(function(el) { return { code: el.code, name: el.name } });
        this.$emit("change", payload);
      }
    }, // end saveMobile
    bpdata_selection: function(val) {
      this.updateHasNoSelection(val);
    },
    treeResults: function(res) {
      this.updateResultsTree(res);
    }
  } // end methods
}; // end export default
</script>

<style>
.open-services-tree-naics-lookup {
  margin-top: 5px;
  margin-left: 5px;
}
@media only screen and (max-width: 767px) {
  .open-services-tree-naics-lookup {
    margin-top: -5px;
    margin-left: -5px;
    margin-right: -5px;
    background-color: #fff;
  }
}
.open-services-tree-naics-lookup .start-button:focus {
  background-color: rgba(255,255,255,1);
  color: #167df0;
}
.open-services-tree-naics-lookup .edit-button {
  margin-left: 5px;
}
.open-services-tree-naics-lookup .edit-button:focus {
  background-color: rgba(255,255,255,1);
  color: #167df0;
}
.open-services-tree-naics-lookup .reset-button {
  margin-left: 6px;
}
.open-services-tree-naics-lookup .reset-button:focus {
  background-color: grey;
  color: rgba(255,255,255,1);
}
.open-services-tree-naics-lookup .format-tree {
  width: 90% !important;
}
.open-services-tree-naics-lookup .format-text {
  margin-left: 15px;
}
</style>
